import {LANGUAGES} from '../../config'
import {entityTypes} from '../conf/entityAdmin'
import {blockTypes} from '../conf/block'

const getBlockInfo = (block, entity) => {
	let info = {}
	info.collection = entity.type==='node' 
			? 'node' 
			: ( (entityTypes[entity.type] && entityTypes[entity.type].collection)
					?entityTypes[entity.type].collection
					:entity.type)
	info.fields = (blockTypes[block.type] && blockTypes[block.type].fields)?blockTypes[block.type].fields:[]
	if (block.e) {
		try {
			info.fields = info.fields.concat(JSON.parse(block.e))
		}catch(e) {
		    //eslint-disable-next-line
		    Bugsnag.notifyException(e)
			console.log(e)
		}
	}
	if(LANGUAGES) {
		info.languages = {}
		if (block.l) {
			LANGUAGES.forEach(l => info.languages[l] = false)
			const langs = block.l.split(',')
			langs.forEach(l => info.languages[l] = true)
		} else {
			LANGUAGES.forEach(l => info.languages[l] = true)
		}

		info.locale = {}
		info.fields.forEach((field,i) => info.locale[field.name] = field.t || false)
		
		if (block.t) {
			const toks = block.t.split(',')
			info.fields.forEach((field,i) => info.locale[field.name] = false)
			toks.forEach(field => info.locale[field] = true)
		}
	}
	return info	
}
export default getBlockInfo



// WEBPACK FOOTER //
// ./src/fm/admin/BlockInfo.js